<template>
    <div class="aside">
      <button class="aside-btn" @click="jumpTo">预约参观</button>
      <button class="aside-btn" @click="jumpTo">在线咨询</button>
      <img src="../../../static/img/index/erweima.png" alt="">
      <p class="sys">扫一扫&nbsp;&nbsp;领优惠 </p>
    </div>
</template>

<script>
    export default {
        name: "aside",
      methods:{
          jumpTo:function () {
            this.$router.push({
              path: `/about/us`,
            })
          }
      }
    }
</script>

<style scoped lang="less">
  .aside{
    position: fixed;
    z-index: 999999;
    display: flex;
    flex-direction: column;
    align-items: center;
    left: 0;
    top: 300px;
    width: 142px;
    height: 267px;
    border-radius: 4px;
    padding: 20px 10px;
    border: 1px solid #cccccc;
    background-color: #ffffff;
    .aside-btn{
      width: 120px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      color:#ffffff;
      border-radius: 16px;
      background-color: #C2874E;
      margin-bottom: 10px;
      border: none;
    }
    img{
      width: 100px;
      height: 100px;
      margin-bottom: 10px;
    }
    .sys{
      color:#999999;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/aside.vue